module.exports = __webpack_public_path__ + "img/meilisearch.0966c0f8.svg";